export interface ConfigInterface {
  AUTH_API_URL: string;
  AUTH_CLIENT_ID: string;
  SERVICE_API_URL: string;
  QM_SERVICE_API_URL: string;
  SENTRY_ENABLED: boolean;
  CURRENT_GIT_HASH: string;
  SENTRY_DSN: string;
  SENTRY_ENVIRONMENT: string;
  PR_NUMBER: string;
  PREVIEW_ID: string | null;
}
const config: ConfigInterface = {
  AUTH_API_URL: `https://${process.env.REACT_APP_OKTA_DOMAIN}/`,
  AUTH_CLIENT_ID: `${process.env.REACT_APP_OKTA_CLIENT_ID}`,
  SERVICE_API_URL: `${process.env.REACT_APP_API_URL}`,
  QM_SERVICE_API_URL: `${process.env.REACT_APP_QM_API_URL}`,
  SENTRY_ENABLED: process.env.REACT_APP_SENTRY_ENABLED === "true",
  CURRENT_GIT_HASH: `${process.env.REACT_APP_CURRENT_GIT_HASH}`,
  SENTRY_DSN: `${process.env.REACT_APP_SENTRY_DSN}`,
  SENTRY_ENVIRONMENT: `${process.env.REACT_APP_SENTRY_ENVIRONMENT}`,
  PR_NUMBER: `${process.env.REACT_APP_PR_NUMBER}`,
  PREVIEW_ID: new URLSearchParams(window?.location?.search?.substring(1)).get("preview"),
};
export default config;
